import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaInfoCircle, FaServicestack, FaEnvelope, FaProjectDiagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
    const { t } = useTranslation();
    
    return (
        <div className="sidebar bg-dark d-flex flex-column align-items-center position-fixed" style={{
            width: '80px',
            minHeight: '100vh',
            top: 0,
            left: 0,
            zIndex: 1000
        }}>
            <div className="my-3">
                <Link to="/" className="d-flex align-items-center justify-content-center text-decoration-none">
                    <div style={{ 
                        backgroundColor: 'rgba(255, 255, 255, 0.15)', 
                        padding: '6px 8px', 
                        borderRadius: '6px',
                        backdropFilter: 'blur(5px)'
                    }}>
                        <img
                            src="https://res.cloudinary.com/dwc20azoo/image/upload/v1749056400/cogeis_bianco_xqtu32.png"
                            alt="Cogeis Logo"
                            style={{ 
                                maxHeight: '60px', 
                                maxWidth: '60px',
                                filter: 'brightness(1.5) contrast(1.2)',
                                opacity: 0.95
                            }}
                        />
                    </div>
                </Link>
            </div>
            <Nav className="flex-column align-items-center w-100 mt-4">
                <OverlayTrigger placement="right" overlay={<Tooltip>{t('sidebarAbout')}</Tooltip>}>
                    <Nav.Link as={Link} to="/about-us" className="text-white d-flex justify-content-center py-3">
                        <FaInfoCircle size={22} />
                    </Nav.Link>
                </OverlayTrigger>
                <OverlayTrigger placement="right" overlay={<Tooltip>{t('sidebarServices')}</Tooltip>}>
                    <Nav.Link as={Link} to="/Servizi" className="text-white d-flex justify-content-center py-3">
                        <FaServicestack size={22} />
                    </Nav.Link>
                </OverlayTrigger>
                <OverlayTrigger placement="right" overlay={<Tooltip>{t('sidebarContact')}</Tooltip>}>
                    <Nav.Link as={Link} to="/Contatti" className="text-white d-flex justify-content-center py-3">
                        <FaEnvelope size={22} />
                    </Nav.Link>
                </OverlayTrigger>
                <OverlayTrigger placement="right" overlay={<Tooltip>{t('sidebarProjects')}</Tooltip>}>
                    <Nav.Link as={Link} to="/Progetti" className="text-white d-flex justify-content-center py-3">
                        <FaProjectDiagram size={22} />
                    </Nav.Link>
                </OverlayTrigger>
            </Nav>
        </div>
    );
};

export default Sidebar;

